<template>
    <div>
        <div class="header pt-5">
            <div>
                {{ headerText }}
            </div>
            <div>
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-2"
                    width="150"
                    color="primary">
                    {{ 'Cancel' }}
                </v-btn>

                <v-btn
                    @click="submitForm()"
                    width="150"
                    color="primary">
                    {{ 'Submit' }}
                </v-btn>
            </div>
        </div>
        <v-container class="pa-0 mt-8">
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        label="Device Name"
                                        v-model="form.name"
                                        placeholder=" "
                                        autocomplete="off"
                                        :error-messages="errors.name"
                                        :rules="inputRules">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                        label="Serial Number"
                                        v-model="form.serial_number"
                                        placeholder=" "
                                        autocomplete="off"
                                        :error-messages="errors.serial_number"
                                        :rules="inputRules">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        label="Endpoint"
                                        v-model="form.endpoint"
                                        placeholder=" "
                                        autocomplete="off"
                                        :error-messages="errors.endpoint"
                                        :rules="inputRules">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-autocomplete
                                        label="Branch"
                                        v-model="form.branch_id"
                                        placeholder=" "
                                        :key="form.branch_id"
                                        :items="$store.state.branches"
                                        :rules="inputRules"
                                        item-text="name"
                                        item-value="id">
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-col class="px-0">
                                <v-autocomplete
                                    label="Employee"
                                    v-model="form.employee_ids"
                                    item-text="fullname"
                                    item-value="id"
                                    :items="employees"
                                    placeholder=" "
                                    multiple
                                >
                                    <template v-slot:prepend-item>
                                            <v-list-item
                                              ripple
                                              @mousedown.prevent
                                              @click="toggleSelectedAll"
                                            >
                                              <v-list-item-action>
                                                <v-icon :color="form.employee_ids.length > 0 ? 'primary' : ''">
                                                  {{ icon }}
                                                </v-icon>
                                              </v-list-item-action>
                                              <v-list-item-content>
                                                <v-list-item-title>
                                                  {{ $vuetify.lang.t('$vuetify.employeeForm.selectAll') }}
                                                </v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mt-2"></v-divider>
                                          </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col class="px-0">
                                <v-checkbox
                                    v-model="form.can_upload"
                                    label="Can upload image to device"
                                    />
                            </v-col>
                    </v-form>
            </v-container>
    </div>
</template>

<script>
export default {
    name: 'DeviceForm',

    data () {
        return {
            dialog: false,
            valid: true,
            form: {
                name: '',
                serial_number: '',
                branch_id: '',
                endpoint: '',
                employee_ids: [],
                can_upload: false
            },
            inputRules: [
                v => !!v || 'this field is required',
                v => (v && v.toString().trim().length > 0) || 'this field is required'
            ],
            errors: [],
            deviceId: '',
            employees: [],
            headerText: '',
            updateDeviceId: -1
        }
    },

    methods: {
        closeModal () {
            this.clearForm()
            this.$refs.form.resetValidation()
            this.$emit('close-modal')
            this.dialog = false
        },

        clearForm () {
            this.form = {
                name: '',
                serial_number: '',
                branch_id: '',
                endpoint: '',
                employee_ids: [],
                can_upload: false
            }
            this.errors = []
        },

        toggleSelectedAll () {
            this.$nextTick(() => {
                if (this.likesAllFruit) {
                    this.form.employee_ids = []
                } else {
                    this.form.employee_ids = this.employees.slice()
                }
            })
        },

        submitForm () {
            if (!this.$refs.form.validate()) {
                return
            }
            if (this.updateDeviceId === null) {
                this.createDevice()
            } else if (this.updateDeviceId !== null) {
                this.updateDevice()
            }
        },

        async createDevice () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('device/create', this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-created')
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: 'Congratulation',
                    text: 'Device is created.',
                    type: 'success'
                })
                this.$router.push({ name: 'Devices' }, () => {})
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: 'Error message',
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async updateDevice () {
            this.$store.dispatch('setLoading', true)
            const url = `device/edit/${this.updateDeviceId}`
            const res = await this.axios.put(url, this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-updated')
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: 'Congratulation',
                    text: 'Device is updated.',
                    type: 'success'
                })
                this.$router.push({ name: 'Devices' }, () => {})
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: 'Error message',
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async getDevice (deviceId) {
            this.$store.dispatch('setLoading', true)
            const url = `device/${deviceId}`
            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                const data = res.data.data
                this.form = {
                    name: data.name,
                    serial_number: data.serial_number,
                    branch_id: data.branch,
                    endpoint: data.endpoint,
                    employee_ids: data.employee_ids,
                    can_upload: data.can_upload
                }
            }
        },

        async getEmployee () {
            let url = 'employees/filter'
            const role = ''
            if (role && role != null) url += `?role=${role}`
            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.employees = res.data.data
            }
        },

        cancel () {
            this.$router.push({ name: 'Devices' }, () => {})
        }

    },

    computed: {
        likesAllFruit () {
            return this.form.employee_ids.length === this.employees.length
        },
        icon () {
            if (this.likesAllFruit) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        }
    },

    watch: {
        '$route.params': {
            async handler (newValue, oldValue) {
                if (newValue.id === undefined) {
                    this.clearForm()
                    this.headerText = 'Create New Device'
                } else {
                    this.updateDeviceId = newValue.id
                    this.headerText = 'Update Device'
                    this.getDevice(this.updateDeviceId)
                }
                await this.getEmployee()
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .action-header {
        display: flex;

        .btn-action {
            margin: 1rem;
        }
    }
}
</style>
